"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _FeaturePanel = require("./FeaturePanel.style");

var _Layout = require("../Layout");

var _Typography = require("../Typography");

var _Button = _interopRequireDefault(require("../Button"));

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var _AddToCalendar = require("../AddToCalendar");

var FeaturePanel = function FeaturePanel(_ref) {
  var id = _ref.id,
      copy = _ref.copy,
      cta = _ref.cta,
      ctas = _ref.ctas,
      image = _ref.image,
      price = _ref.price,
      textPosition = _ref.textPosition,
      title = _ref.title,
      variant = _ref.variant,
      video = _ref.video;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      featurePanels = _ref2.featurePanels;

  var mediaProps = image ? _objectSpread(_objectSpread({}, image), {}, {
    alt: 'Img Text',
    mediaType: 'image'
  }) : _objectSpread(_objectSpread({}, video), {}, {
    aspectRatio: variant === 'tertiary' ? '21:9' : video.aspectRatio,
    mediaType: 'video'
  });
  var containerProps = {
    primary: {},
    secondary: {
      px: 0
    },
    tertiary: {
      px: 0
    }
  };
  var copyColumnOptions = {
    primary: featurePanels.primaryCopyColumnWidth,
    secondary: [12, null, 6, 6],
    tertiary: [12, null, 4]
  };
  var featureMediaColumnOptions = {
    primary: featurePanels.primaryMediaColumnWidth,
    secondary: [12, null, 6, 6],
    tertiary: [12, null, 8]
  };
  var hasCta = !!cta.url && !!cta.label; // DEPRECATED, use ctas instead

  var hasCtas = ctas && ctas.length > 0;
  var btnVariants = ['primary', 'secondary'];
  return /*#__PURE__*/_react.default.createElement(_Layout.Container, containerProps[variant], /*#__PURE__*/_react.default.createElement(_FeaturePanel.FeaturePanelGrid, {
    image: image,
    variant: variant,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: copyColumnOptions[variant]
  }, /*#__PURE__*/_react.default.createElement(_FeaturePanel.ContentWrapper, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    size: featurePanels.titleFontSize
  }, title), copy && /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    as: "div",
    mt: "small"
  }, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: copy,
    copySize: featurePanels.copyFontSize
  })), (cta || price) && !hasCtas && /*#__PURE__*/_react.default.createElement(_FeaturePanel.FeaturePanelFlex, {
    variant: variant,
    price: price
  }, price && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_FeaturePanel.StrikeThroughText, {
    "data-test": "strikeThrough"
  }, price.previous), /*#__PURE__*/_react.default.createElement(_FeaturePanel.RegularText, {
    "data-test": "currentPrice"
  }, price.current)), hasCta && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: featurePanels.buttonVariant
  }, cta), cta.label)), hasCtas && /*#__PURE__*/_react.default.createElement(_FeaturePanel.CTAsWrapper, null, ctas.map(function (action, index) {
    var btnVariant = btnVariants[index];

    if (action.startTime) {
      return /*#__PURE__*/_react.default.createElement(_FeaturePanel.FeaturePanelFlex, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        key: index.toString(),
        disabled: !!action.disabled,
        variant: btnVariant,
        calendarEvent: action
      }, action.title));
    }

    return /*#__PURE__*/_react.default.createElement(_FeaturePanel.FeaturePanelFlex, null, /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
      key: index.toString(),
      variant: btnVariant
    }, action), action.label));
  })))), /*#__PURE__*/_react.default.createElement(_FeaturePanel.FeatureMediaColumn, {
    width: featureMediaColumnOptions[variant],
    textPosition: textPosition
  }, /*#__PURE__*/_react.default.createElement(_FeaturePanel.FeatureMedia, mediaProps))));
};

var requiredPropsCheck = function requiredPropsCheck(_ref3, _, componentName) {
  var image = _ref3.image,
      video = _ref3.video;

  if (!image && !video) {
    return new Error("One of 'video' or 'image' is required by '".concat(componentName, "' component."));
  }

  return null;
};

FeaturePanel.propTypes = {
  id: _propTypes.default.string,
  copy: _propTypes.default.string,
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.oneOf(['primary', 'secondary', 'link']),
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),
  ctas: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes), _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired,
    variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary', 'link'])
  })])),
  image: requiredPropsCheck,
  price: _propTypes.default.shape({
    current: _propTypes.default.string,
    previous: _propTypes.default.string
  }),
  textPosition: _propTypes.default.oneOf(['right', 'left']),
  title: _propTypes.default.string.isRequired,
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),
  video: requiredPropsCheck
};
FeaturePanel.defaultProps = {
  id: '',
  copy: '',
  cta: {
    label: '',
    url: null,
    calendarEvent: null
  },
  ctas: [],
  image: null,
  textPosition: 'right',
  price: null,
  variant: 'primary',
  video: null
};
var _default = FeaturePanel;
exports.default = _default;